
@if (view.quickBookLoading) {
    <div class="flex items-center gap-3 mb-6 px-4 py-3 rounded-lg border border-primary-200 bg-primary-50 text-primary-800">
        <mat-icon class="icon-size-6" [svgIcon]="'heroicons_outline:bolt'"></mat-icon>
        <div class="text-sm font-semibold">Preparing your quick book search...</div>
    </div>
}
@if (view.quickBookBundle) {
    <div class="flex flex-col gap-1 mb-6 px-4 py-3 rounded-lg border border-gray-200 bg-white">
        <div class="text-xs uppercase tracking-widest text-gray-500">Quick book bundle</div>
        <div class="text-lg font-semibold text-gray-900">{{ view.quickBookBundle?.name || view.quickBookBundle?.supplierName }}</div>
        <div class="text-sm text-gray-600">Dynamic pricing rerun in progress based on the bundle rules.</div>
    </div>
}

<mat-horizontal-stepper [linear]="true" #stepperPackages class="bg-transparent mb-100">
    <mat-step>
        <ng-template matStepLabel>
            <h3>Search</h3>
        </ng-template>       

        <search-widget [cacheMode]="view.cacheMode" (searchClicked)="searchClicked()" (tripChange)="tripChanged($event)" (searchChange)="searchChanged($event)"
            [panel]="{type: 'package', title: 'Express Package', heading: 'Where do you want to go?', description: 'Search, build and share your own packages.'}"></search-widget>
    </mat-step>
    <mat-step>
        <ng-template matStepLabel>Packages</ng-template>
        <div class="flex justify-between">
            <!-- <button class="px-8 w-50" mat-flat-button [color]="'secondary'" type="button" matStepperPrevious>Select Flights</button> -->
            <button class="px-8 w-50" mat-flat-button [color]="'secondary'" type="button" matStepperPrevious>Change
                Search</button>
            <button class="px-8" mat-flat-button [color]="'primary'" type="button" matStepperNext>Review</button>
        </div>

        @if (view.search && !(view.search.flights && view.search.transfers && view.transfersReceived >= 2) && view.trip) {
            @for (point of view.trip.points; track point) {
                @if (point.type == 'hotel') {
                <!-- Header -->
                <div class="flex flex-col items-center">
                    <h2 class="text-xl font-semibold text-center">Express Package</h2>
                    <div class="mt-1 text-3xl sm:text-7xl font-extrabold tracking-tight leading-tight text-center">
                      {{point.title}}
                    </div>
                    <div class="mt-3 sm:text-xl text-center tracking-tight text-secondary">
                        <div class="">{{ (view.search.dateFrom | date) }} - {{ (view.search.dateTo | date) }}</div>
                    </div>
                </div>
                }
            }

            <div class="flex flex-col flex-auto items-center justify-center">
                <mat-icon class="icon-size-24" [svgIcon]="'heroicons_outline:chat-bubble-oval-left-ellipsis'"></mat-icon>
                @if (view.searchError) {
                <div class="mt-4 text-lg tracking-tight text-red-600 text-center">We couldn't complete this search.</div>
                <div class="mt-1 text-sm text-secondary text-center">Please adjust your search and try again.</div>
                }
                @if (!view.searchError && (!view.statusses || view.statusses.length == 0)) {
                <div class="mt-4 text-lg tracking-tight text-secondary text-center">One moment...</div>
                <div class="spinner">
                    <div class="bounce1 bg-primary"></div>
                    <div class="bounce2 bg-primary"></div>
                    <div class="bounce3 bg-primary"></div>
                </div>
                }
                @if (view.statusses && view.statusses.length > 0) {
                    @for (status of view.statusses; track status) {
                    <div class="flex flex-row justify-center items-center p-2">
                        <mat-icon class="icon-size-8" [class.animate-pulse]="!status.isComplete && !status.isError" [class.text-primary-500]="status.isComplete" [class.text-red-500]="status.isError" [svgIcon]="status.isError ? 'heroicons_outline:x-circle' : 'heroicons_outline:check-circle'"></mat-icon>
                        <div class="text-lg tracking-tight text-center">
                            <span [ngClass]="{ 'ai-status': !status.isError, 'ai-status-error': status.isError }">
                                {{status.typedText || status.text}}
                            </span>
                            <span class="ai-cursor" *ngIf="status.isTyping && !status.isError"></span>
                        </div>
                    </div>
                    }
                @if (!view.searchError) {
                <div class="spinner">
                    <div class="bounce1 bg-primary"></div>
                    <div class="bounce2 bg-primary"></div>
                    <div class="bounce3 bg-primary"></div>
                </div>
                }
                }
            </div>

            <div class="flex flex-col flex-auto items-center justify-center">
                <!-- <mat-icon class="icon-size-24" [svgIcon]="'heroicons_outline:chat-bubble-oval-left-ellipsis'"></mat-icon> -->
                
            </div>
        }

        <stay-list *ngIf="view.search && view.trip && view.search.flights && view.search.transfers && view.transfersReceived >= 2" [options]="view.search" [trip]="view.trip" [cacheMode]="view.cacheMode" [displayMode]="'list'" (resultChange)="resultChanged($event)" (searchChangeRequested)="goBackToSearch()" (flightReplaced)="onFlightReplaced()"></stay-list>
    </mat-step>
</mat-horizontal-stepper>

<div *ngIf="view.search && view.trip && view.flightSearchReady" class="hidden">
    <flight-list [options]="view.search" [trip]="view.trip" [cacheMode]="view.cacheMode" (resultChange)="resultChanged($event)"></flight-list>
    <!-- <flight-list [options]="view.search" [trip]="view.trip" [cacheMode]="view.cacheMode" (resultChange)="resultChanged($event)"></flight-list> -->

    <!-- Car hire at destination (same logic as working platform: show when we have flights and a destination point) -->
    <car-list #carListRef *ngIf="view.search && view.search.flights && view.trip.points.length >= 2 && view.trip.points[1]" [options]="view.search" [trip]="view.trip" [point]="view.trip.points[1]" [pointTo]="view.trip.points[1]" [cacheMode]="view.cacheMode" (resultChange)="resultChanged($event, 0)"></car-list>

    <!-- Airport to resort = INBOUND -->
    <transfer-list *ngIf="view.search && view.search.flights" [options]="view.search" [trip]="view.trip" [point]="view.trip.points[2]" [pointTo]="view.trip.points[1]" [cacheMode]="view.cacheMode" (resultChange)="resultChanged($event, 0)"></transfer-list>
    <!-- Resort to airport = OUTBOUND -->
    <transfer-list *ngIf="view.search && view.search.flights" [options]="view.search" [trip]="view.trip" [point]="view.trip.points[1]" [pointTo]="view.trip.points[2]" [cacheMode]="view.cacheMode" (resultChange)="resultChanged($event, 1)"></transfer-list>
</div>

<div class="relative flex flex-col flex-auto min-w-0 overflow-hidden hidden">

    <!-- Header & Cards -->
    <div class="relative pt-8 pb-12 sm:pt-10 sm:pb-12 px-6 sm:px-16 overflow-hidden">
        <!-- Header -->
        <div class="flex flex-col items-center">
            <h2 class="text-xl font-semibold">POPULAR PACKAGES</h2>
            <div class="mt-1 text-3xl sm:text-3xl font-extrabold tracking-tight leading-tight text-center">
                Discover the World!
            </div>
            <div class="mt-3 sm:text-2xl text-center tracking-tight text-secondary">
                <div class="">Search, build and share your own packages.</div>
            </div>
            <!-- Recurring selector -->

            <div class="flex items-center mt-8 sm:mt-16 p-0.5 rounded-full overflow-hidden bg-gray-200 dark:bg-gray-700">
                @for (destination of view.destinations; track destination) {
                <button class="px-6" [ngClass]="{'bg-card shadow': destination.selected, 'bg-transparent': !destination.selected }" mat-flat-button (click)="toggleFilter(destination)" disableRipple>
                    {{ destination.name }}
                </button>
                }
            </div>

        </div>
        <!-- Cards -->
        <div class="flex justify-center mt-10 sm:mt-20">
            <div class="w-full max-w-sm md:max-w-7xl">
                <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-6 lg:gap-y-0 md:gap-x-6 lg:gap-x-0">
                    <!-- Card 1 -->
                    <fuse-card
                        class="flex-col items-center max-w-sm md:max-w-none lg:my-16 lg:rounded-none lg:rounded-l-2xl">
                        <div class="w-full rounded-t-2xl bg-cover bg-no-repeat bg-center bg-origin-border">
                            <div>
                                <img src="https://www.elephanthillshotel.com/wp-content/uploads/Exterior/aerial-view-ehh-1024x683.jpg" alt="">
                                <div class="py-4 px-3">
                                    <mat-icon class="mx-2" [matTooltip]="'Transfers'" svgIcon="mat_solid:directions_car"></mat-icon>
                                    <mat-icon class="mx-2" [matTooltip]="'Accommodation'" svgIcon="mat_outline:king_bed"></mat-icon>
                                </div>
                            </div>
                            <!-- Features -->
                            <div class="sm:py-2 sm:px-8">
                                <div class="flex-col items-center justify-start">
                                    <div class="text-3xl font-bold tracking-tight text-left h-15">Elephant Hills</div>
                                    <mat-icon class="text-yellow-500" svgIcon="heroicons_solid:star"></mat-icon>
                                    <mat-icon class="text-yellow-500" svgIcon="heroicons_solid:star"></mat-icon>
                                    <mat-icon class="text-yellow-500" svgIcon="heroicons_solid:star"></mat-icon>
                                    <div class="mt-2 text-lg font-medium tracking-tight text-left text-secondary">Perfect getaway for the family</div>
                                    <div class="w-8 h-1 my-3 rounded bg-accent"></div>
                                </div>
                                <!-- Pricing -->
                                <div class="flex items-baseline whitespace-nowrap">
                                    <div class="mr-2 text-2xl">from</div>
                                    <div class="text-3xl font-semibold leading-tight tracking-tight">
                                        <ng-container>R37,449.72</ng-container>
                                    </div>
                                </div>
                            <button class="fuse-mat-button-large mt-5 w-full bg-green-500" mat-flat-button [color]="'primary'">Select</button>
                            <div class="mt-3 -mx-3 ">
                                <button mat-button class="text-primary">
                                    <span class="mr-1">What's included?</span>
                                </button>
                            </div>
                            <ng-container fuseCardExpansion>
                                <div class="mt-4 space-y-2">
                                    <div class="flex">
                                        <mat-icon class="icon-size-5 text-green-600" [svgIcon]="'heroicons_solid:check'"></mat-icon>
                                        <div class="ml-2 leading-5">Standard Room (Golf, Game & River View)</div>
                                    </div>
                                    <div class="flex">
                                        <mat-icon class="icon-size-5 text-green-600" [svgIcon]="'heroicons_solid:check'"></mat-icon>
                                        <div class="ml-2 leading-5">Transfers</div>
                                    </div>
                                    <div class="flex">
                                        <mat-icon class="icon-size-5 text-green-600" [svgIcon]="'heroicons_solid:check'"></mat-icon>
                                        <div class="ml-2 leading-5">Bed and Breakfast</div>
                                    </div>
                                </div>
                            </ng-container>
                            </div>
                        </div>
                    </fuse-card>
                    <!-- Card 2 -->
                    <fuse-card
                        class="flex-col items-center max-w-sm md:max-w-none lg:shadow-2xl lg:rounded-l-2xl lg:rounded-r-2xl">
                        <div class="w-full rounded-t-2xl bg-cover bg-no-repeat bg-center bg-origin-border">
                            <div>
                                <img src="https://wallowlodge.com/wp-content/uploads/2022/10/RateSH2.jpg" alt="">
                                <div class="py-4 px-3">
                                    <mat-icon class="mx-2" [matTooltip]="'Flights'" svgIcon="airplanemode_active"></mat-icon>
                                    <mat-icon class="mx-2" [matTooltip]="'Transfers'" svgIcon="mat_solid:directions_car"></mat-icon>
                                    <mat-icon class="mx-2" [matTooltip]="'Accommodation'" svgIcon="mat_outline:king_bed"></mat-icon>
                                </div>
                            </div>
                            <!-- Features -->
                            <div class="sm:py-2 sm:px-8">
                                <div class="flex-col items-center justify-start">
                                    <div class="text-3xl font-bold tracking-tight text-left h-15">The Wallow Lodge</div>
                                    <mat-icon class="text-yellow-500" svgIcon="heroicons_solid:star"></mat-icon>
                                    <mat-icon class="text-yellow-500" svgIcon="heroicons_solid:star"></mat-icon>
                                    <mat-icon class="text-yellow-500" svgIcon="heroicons_solid:star"></mat-icon>
                                    <mat-icon class="text-yellow-500" svgIcon="heroicons_solid:star"></mat-icon>
                                    <mat-icon class="text-yellow-500" svgIcon="heroicons_solid:star"></mat-icon>
                                    <div class="mt-2 text-lg font-medium tracking-tight text-left text-secondary">Perfect getaway for the family</div>
                                    <div class="w-8 h-1 my-3 rounded bg-accent"></div>
                                </div>
                                <!-- Pricing -->
                                <div class="flex items-baseline whitespace-nowrap">
                                    <div class="mr-2 text-2xl">from</div>
                                    <div class="text-3xl font-semibold leading-tight tracking-tight">
                                        <ng-container>R37,449.72</ng-container>
                                    </div>
                                </div>
                            <button class="fuse-mat-button-large mt-5 w-full bg-green-500" mat-flat-button [color]="'primary'">Select</button>
                            <div class="mt-3 -mx-3 ">
                                <button mat-button class="text-primary">
                                    <span class="mr-1">What's included?</span>
                                </button>
                            </div>
                            <ng-container fuseCardExpansion>
                                <div class="mt-4 space-y-2">
                                    <div class="flex">
                                        <mat-icon class="icon-size-5 text-green-600" [svgIcon]="'heroicons_solid:check'"></mat-icon>
                                        <div class="ml-2 leading-5">Flights</div>
                                    </div>
                                    <div class="flex">
                                        <mat-icon class="icon-size-5 text-green-600" [svgIcon]="'heroicons_solid:check'"></mat-icon>
                                        <div class="ml-2 leading-5">Transfers</div>
                                    </div>
                                    <div class="flex">
                                        <mat-icon class="icon-size-5 text-green-600" [svgIcon]="'heroicons_solid:check'"></mat-icon>
                                        <div class="ml-2 leading-5">Double Tented Suite</div>
                                    </div>
                                    <div class="flex">
                                        <mat-icon class="icon-size-5 text-green-600" [svgIcon]="'heroicons_solid:check'"></mat-icon>
                                        <div class="ml-2 leading-5">Golf</div>
                                    </div>
                                    <div class="flex">
                                        <mat-icon class="icon-size-5 text-green-600" [svgIcon]="'heroicons_solid:check'"></mat-icon>
                                        <div class="ml-2 leading-5">Horse Riding</div>
                                    </div>
                                    <div class="flex">
                                        <mat-icon class="icon-size-5 text-green-600" [svgIcon]="'heroicons_solid:check'"></mat-icon>
                                        <div class="ml-2 leading-5">All inclusive</div>
                                    </div>
                                </div>
                            </ng-container>
                            </div>
                        </div>
                    </fuse-card>
                    <!-- Card 3 -->
                    <fuse-card
                        class="flex-col items-center max-w-sm md:max-w-none lg:my-16 lg:rounded-none lg:rounded-r-2xl">
                        <div class="w-full rounded-t-2xl bg-cover bg-no-repeat bg-center bg-origin-border">
                            <div>
                                <img src="https://www.olddriftlodge.com/wp-content/uploads/2021/10/197886702_10223371194982023_3850351918174286330_n-980x653.jpeg" alt="">
                                <div class="py-4 px-3">
                                    <mat-icon class="mx-2" [matTooltip]="'Flights'" svgIcon="airplanemode_active"></mat-icon>
                                    <mat-icon class="mx-2" [matTooltip]="'Transfers'" svgIcon="mat_solid:directions_car"></mat-icon>
                                </div>
                            </div>
                            <!-- Features -->
                            <div class="sm:py-2 sm:px-8">
                                <div class="flex-col items-center justify-start">
                                    <div class="text-3xl font-bold tracking-tight text-left h-15">Old Drift Lodge</div>
                                    <mat-icon class="text-yellow-500" svgIcon="heroicons_solid:star"></mat-icon>
                                    <mat-icon class="text-yellow-500" svgIcon="heroicons_solid:star"></mat-icon>
                                    <mat-icon class="text-yellow-500" svgIcon="heroicons_solid:star"></mat-icon>
                                    <mat-icon class="text-yellow-500" svgIcon="heroicons_solid:star"></mat-icon>
                                    <div class="mt-2 text-lg font-medium tracking-tight text-left text-secondary">Perfect getaway for the family</div>
                                    <div class="w-8 h-1 my-3 rounded bg-accent"></div>
                                </div>
                                <!-- Pricing -->
                                <div class="flex items-baseline whitespace-nowrap">
                                    <div class="mr-2 text-2xl">from</div>
                                    <div class="text-3xl font-semibold leading-tight tracking-tight">
                                        <ng-container>R37,449.72</ng-container>
                                    </div>
                                </div>
                            <button class="fuse-mat-button-large mt-5 w-full bg-green-500" mat-flat-button [color]="'primary'">Select</button>
                            <div class="mt-3 -mx-3 ">
                                <button mat-button class="text-primary">
                                    <span class="mr-1">What's included?</span>
                                </button>
                            </div>
                            <ng-container fuseCardExpansion>
                                <div class="mt-4 space-y-2">
                                    <div class="flex">
                                        <mat-icon class="icon-size-5 text-green-600" [svgIcon]="'heroicons_solid:check'"></mat-icon>
                                        <div class="ml-2 leading-5">Double Tented Suite</div>
                                    </div>
                                    <div class="flex">
                                        <mat-icon class="icon-size-5 text-green-600" [svgIcon]="'heroicons_solid:check'"></mat-icon>
                                        <div class="ml-2 leading-5">Flights</div>
                                    </div>
                                    <div class="flex">
                                        <mat-icon class="icon-size-5 text-green-600" [svgIcon]="'heroicons_solid:check'"></mat-icon>
                                        <div class="ml-2 leading-5">Transfers</div>
                                    </div>
                                    <div class="flex">
                                        <mat-icon class="icon-size-5 text-green-600" [svgIcon]="'heroicons_solid:check'"></mat-icon>
                                        <div class="ml-2 leading-5">All Inclusive</div>
                                    </div>
                                </div>
                            </ng-container>
                            </div>
                        </div>
                    </fuse-card>
                </div>
            </div>
        </div>
    </div>
</div>
